var shopifyRichTextRenderer = shopifyRichTextRenderer || {};
shopifyRichTextRenderer.ConvertSchemaToHtml = function(schema, scoped = false) {  
  this.buildParagraph = function(el) {
    if (el?.children) {
      return `<p>${this.convertSchemaToHtml(el?.children)}</p>`
    }
  };  
  this.convertSchemaToHtmlbuildHeading=function(el) {
    if (el?.children) {
      return `<h${el?.level}>${this.convertSchemaToHtml(el?.children)}</h${el?.level}>`
    }
  };  
  this.buildList= function(el) {
    if (el?.children) {
      if (el?.listType === 'ordered') {
        return `<ol>${this.convertSchemaToHtml(el?.children)}</ol>`
      } else {
        return `<ul>${this.convertSchemaToHtml(el?.children)}</ul>`
      }
    }
  };  
  this.buildListItem= function(el) {
    if (el?.children) {
      return `<li>${this.convertSchemaToHtml(el?.children)}</li>`
    }
  };  
  this.buildLink= function(el) {
    return `<a href="${el?.url}" title="${el?.title}" target="${
      el?.target
    }">${this.convertSchemaToHtml(el?.children)}</a>`
  };  
  this.buildText= function(el) {
    if (el?.bold) {
      return `<strong>${el?.value}</strong>`
    }
    if (el?.italic) {
      return `<em>${el?.value}</em>`
    }
    return el?.value
  };
  this. convertSchemaToHtml= function(schema, scoped = false){
    if (typeof schema === 'string' || schema instanceof String) {
      schema = JSON.parse(schema)
    }
    let html = ``
    if (schema.type === 'root' && schema.children.length > 0) {
      if (scoped) {
        html += `
        <div class="${scoped === true ? `rte` : scoped}">
          ${this.ConvertSchemaToHtml(schema.children)}
        </div>
        `
      } else {
        html += this.convertSchemaToHtml(schema.children)
      }
    } else {
      for (const el of schema) {
        switch (el.type) {
          case 'paragraph':
            html += this.buildParagraph(el)
            break
          case 'heading':
            html += this.buildHeading(el)
            break
          case 'list':
            html += this.buildList(el)
            break
          case 'list-item':
            html += this.buildListItem(el)
            break
          case 'link':
            html += this.buildLink(el)
            break
          case 'text':
            html += this.buildText(el)
            break
          default:
            break
        }
      }
    }
    return html;
  };
  return this.convertSchemaToHtml(schema,scoped); 
}

